export default __webpack_public_path__ + "static/media/efficiency1.5d7620fb.png";